











































import {Vue, Component} from 'vue-property-decorator';
import { mapGetters } from "vuex";
import firebase from "firebase";
import HomeViewModule from '@/store/view/HomeViewModule';
import router from '@/router/index';
import {TodoDataServicesCollection} from '@/accessors/TodoDataServicesCollection';
import WhyDocumentDialog from '@/components/WhyDialog.vue';
import {Loading} from 'quasar';
import { ITopicFilter } from '../models/document';

@Component({
    components: {
        WhyDocumentDialog,
    }
})
export default class NavBar extends Vue {
    public model: any = null;
    public options: any = HomeViewModule.documentSearchTopics;

    public get user() {
            return this.$store.getters.user;
    }
    
    public navigateHome() {
        HomeViewModule.clearTopicFilter();
        if(!['home'].includes(this.$route.name || '')) {
            router.push({name: 'home'});
        }
    }

    public navigateWhy() {
        HomeViewModule.loadPromptWhyDocumentDialog(true);
    }

    public navigateLogin() {
        router.push({name: 'login'});
    }

    public navigateRegister() {
        router.push({name: 'register'});
    }

    public signOut() {
        firebase
        .auth()
        .signOut()
        .then(() => {
            this.$router.replace({
            name: "home"
            });
        });
    }

    public setModel(val: any) {
        this.navigateHome();
        this.model = val;
        HomeViewModule.loadTopicFilter(val);
    }

    public filterFn(val: string, update: ((cb: (() => void)) => void), abort: any) {
        update(() => {
            const needle = val.toLocaleLowerCase();
            this.options = HomeViewModule.documentSearchTopics.filter((v) => v.toLocaleLowerCase().indexOf(needle) > -1);
        });
    }
};
